import { useEffect, useRef, useState } from "react";

import { Modal } from "./Modal";
import { HeaderModal } from "./Header";
import { Body } from "./Body";

import closeIcon from "assets/images/close-icon.svg";
import allImgPaths from "assets/images";
import { useParams } from "react-router-dom";
import { ACTUAL_TASK_NAMES, LOGISTICS_AND_OTHERS_ACTIONS_TABS } from "utils/constant";
import MeetingSpace from "components/logistics/MeetingSpace";
import Accomodation from "components/logistics/Accomodation";
import Transportation from "components/logistics/Transportation";
import DietaryRequirements from "components/logistics/DietaryRequirements";
import Accessibility from "components/logistics/Accessibility";
import EmergencyHealthServices from "components/logistics/EmergencyHealthServices";
import Security from "components/logistics/Security";
import LegalComplianceSustainability from "components/logistics/LegalComplianceSustainability";
import { getLogistics } from "services/chat";
import useAppState from "context/useAppState";
import { differenceInDays } from "date-fns";
import { cloneDeep } from "lodash";
import { jsonToMarkdown } from "utils/function";
import { getLLMAgentRAGUpdatePayload } from "services/llm/payloads";

const logisticOptionsLists = [
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.meeting_spaces
  },
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.accomodation
  },
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.transportation
  },
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.dietary_requirements
  },
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.accessibility
  },
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.emergency_health_services
  },
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.security
  },
  {
    tabName: LOGISTICS_AND_OTHERS_ACTIONS_TABS.legal_compliance_sustainability
  }
]

const LogisticsModal = ({ defaultTab, isShowModal, setOpenLogisticsModal, isViewMode }: any) => {
  const { id: eventId } = useParams();
  const [isLogisticSelect, setIsLogisticSelect] = useState<any>(1);
  const [logisticsData, setLogisticsData] = useState<any>({})
  const { setState: setEventDataState, eventFetchedData, unsavedChanges, currentTaskObj } = useAppState("eventData");
  const [totalDays, setTotalDays] = useState<any>([]);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const { selectedCardDetail } = useAppState("cardWrapper");
  const { updateRAGEntryOfFete } = useAppState('chatBox');
  const [logisticsId, setLogisticsId] = useState<any>(Date.now())

  useEffect(() => {
    setEventData()
    fetchLogistics()
  }, [])

  const fetchLogistics = async () => {
    const { data } = await getLogistics(eventId)
    if (data?.content) {
      setLogisticsData(data.content)
      setLogisticsId(data._id);
    } else {
      setLogisticsData({})
    }
  }

  useEffect(() => {
    const index = logisticOptionsLists.findIndex((lo: any) => lo.tabName.toLowerCase() == defaultTab.toLowerCase())
    if (index > -1) {
      setIsLogisticSelect(index);
      if (index > 3) {
        handleScroll('right')
      }
    }
  }, [])

  const setEventData = () => {
    const startDate = eventFetchedData?.start_date;
    const endDate = eventFetchedData?.end_date;
    const numberOfDays = differenceInDays(endDate, startDate) + 1;

    const totalDaysArr: any = []
    Array.from({ length: numberOfDays }, (_, index: any) => {
      totalDaysArr.push(
        { title: `Day ${index + 1}`, isChecked: false }
      )
    })
    setTotalDays(totalDaysArr)
  }

  const handleScroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        top: 0,
        left: direction === 'left' ? -200 : 500,
        behavior: 'smooth'
      });
    }
  };

  const changeTab = (e: any, index: number, name: string) => {
    if (unsavedChanges) {
      const message = `You’ve unsaved changes in your current tab. Are you sure you want to leave?`
      const confirmLeave = window.confirm(message);
      if (!confirmLeave) {
        e.preventDefault()
        return
      } else {
        setEventDataState({ unsavedChanges: false })
        setIsLogisticSelect(index)
      }
    } else {
      setIsLogisticSelect(index)
    }
  }

  const closeModal = (e: any) => {
    if (unsavedChanges) {
      const message = `You’ve unsaved changes in your current tab. Are you sure you want to leave?`
      const confirmLeave = window.confirm(message);
      if (!confirmLeave) {
        e.preventDefault()
        return
      } else {
        setEventDataState({ unsavedChanges: false })
        setOpenLogisticsModal(false)
      }
    } else {
      setOpenLogisticsModal(false)
    }
  }

  const updateLogisticsState = async (arg: any) => {
    const clonedData = cloneDeep(logisticsData)
    clonedData[arg.type] = arg.data;
    setLogisticsData(clonedData)
    setLogisticsId(arg?.ragId)

    // Add to RAG
    if (arg?.updateRag) {
      await handleRAGCall({ content: clonedData, ragId: arg.ragId })
    }
  }

  const handleRAGCall = async ({ content, ragId }: any) => {
    const userData = JSON.parse(localStorage.getItem('userData') as string)
    const userEmail = localStorage.getItem('userEmail')
    const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

    let ragPayload: any = {
      text_content: jsonToMarkdown({ content: content, isLogistics: true }),
      text_prefix: 'Logistics',
    }

    const taskId = selectedCardDetail?.['tasks'].find((tsk: any) => tsk.title.toLowerCase() == ACTUAL_TASK_NAMES.FETE_PROGRAM.DRAFT.toLowerCase())?._id;
    const ragMetaData = {
      userId: userData?.id,
      userEmail,
      teamId: currentTeam?.currentTeamId,
      eventId: eventId,
      is_draft: false,
      taskId: taskId || currentTaskObj?.task_id,
      updatedAt: new Date().toISOString(),
      cardId: selectedCardDetail?._id
    }

    ragPayload = { ...ragPayload, document_path: ragId || logisticsId, additional_metadata: ragMetaData }

    try {
      await updateRAGEntryOfFete(getLLMAgentRAGUpdatePayload(ragPayload))
    } catch (error) {
      console.log({ ragUpdateError: error })
    }
  }

  return (
    <>
      <Modal className={"modal-wrapper max-w-[758px]"} isShow={isShowModal}>
        <div>
          <HeaderModal title={"test"} isShowHeader={true} className="modal-header pt-6 px-6">
            <div className="flex items-center justify-between">
              <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                Logistics Requirements
              </h2>
              <img
                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1 -mt-[10px]"
                id="modal-toggle"
                src={closeIcon}
                onClick={closeModal}
                alt="close icon"
              />
            </div>
          </HeaderModal>

          <Body title="" isShowBody={true} className="modal-body px-6 pt-5">
            <div>
              <div className="">
                {/* Tab Titles */}
                <div className="flex items-center justify-center w-full mb-2">
                  <img className="cursor-pointer on-hover-bg-grey rounded" src={allImgPaths.leftArrow} alt="" onClick={() => handleScroll('left')} />
                  <div
                    id="scrollBoardContainer"
                    ref={scrollContainerRef}
                    className="flex items-center justify-around no-scrollbar overflow-x-auto h-[48px] w-[calc(100vw_-_225px)]"
                  >
                    {
                      logisticOptionsLists.map((listItem: any, idx: number) => (
                        <span
                          key={idx}
                          className={`block text-sm font-interSemiBold hover:text-[#1E0AF5] rounded-md py-2 px-4 cursor-pointer whitespace-nowrap ${isLogisticSelect === idx ? "bg-[#E8E6FE] text-[#1E0AF5]" : "text-[#667085]"}`}
                          onClick={(e: any) => changeTab(e, idx, listItem)}
                        >
                          {listItem.tabName}
                        </span>
                      ))
                    }
                  </div>
                  <img className="cursor-pointer on-hover-bg-grey rounded" src={allImgPaths.rightArrow} onClick={() => handleScroll('right')} alt="" />
                </div>

                {/* Tabs Content */}
                <div id="" className={``}>
                  {
                    Object.keys(logisticsData).length == 0 &&
                    <>
                      {
                        isLogisticSelect === 0 &&
                        <MeetingSpace
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                      {
                        isLogisticSelect === 1 &&
                        <Accomodation
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                      {
                        isLogisticSelect === 2 &&
                        <Transportation
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                      {
                        isLogisticSelect === 3 &&
                        <DietaryRequirements
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                      {
                        isLogisticSelect === 4 &&
                        <Accessibility
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                      {
                        isLogisticSelect === 5 &&
                        <EmergencyHealthServices
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                      {
                        isLogisticSelect === 6 &&
                        <Security
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                      {
                        isLogisticSelect === 7 &&
                        <LegalComplianceSustainability
                          data={null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                        />
                      }
                    </>
                  }
                  {
                    Object.keys(logisticsData).length > 0 &&
                    <>
                      {
                        isLogisticSelect === 0 &&
                        <MeetingSpace
                          data={logisticsData?.meeting_spaces || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                      {
                        isLogisticSelect === 1 &&
                        <Accomodation
                          data={logisticsData?.accomodation || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                      {
                        isLogisticSelect === 2 &&
                        <Transportation
                          data={logisticsData?.transportation || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                      {
                        isLogisticSelect === 3 &&
                        <DietaryRequirements
                          data={logisticsData?.dietary_requirements || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                      {
                        isLogisticSelect === 4 &&
                        <Accessibility
                          data={logisticsData?.accessibility || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                      {
                        isLogisticSelect === 5 &&
                        <EmergencyHealthServices
                          data={logisticsData?.emergency_health_services || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                      {
                        isLogisticSelect === 6 &&
                        <Security
                          data={logisticsData?.security || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                      {
                        isLogisticSelect === 7 &&
                        <LegalComplianceSustainability
                          data={logisticsData?.legal_compliance_sustainability || null}
                          totalEventDays={totalDays}
                          updateLogisticsState={updateLogisticsState}
                          isViewMode={isViewMode}
                        />
                      }
                    </>
                  }
                </div>
              </div>
            </div>
          </Body>

          {/* <FooterModal title="" isShowFooter={true} className="modal-footer pt-5 px-6 pb-5 border-t border-[#E4E7EC]">
            <div className="flex items-center gap-x-3 justify-end">
              <button
                type="button"
                onClick={() => {
                  setOpenLogisticsModal(false);
                }}
                className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-5 !text-base hover:bg-[#F2F4F7]"
              >
                Reset
              </button>
              <button className="!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg px-5 py-2.5" type="submit">
                Save
              </button>
            </div>
          </FooterModal> */}
        </div>
      </Modal>
    </>
  );
}

export default LogisticsModal;
